export default __webpack_public_path__ + "images/omg_4fc058.svg";